import { ARCHETYPES, ARCHETYPE_OPIS, Archetype, VrstaTerena } from '../world/heightmap'

export interface HudOpts {
  vrsta: VrstaTerena
  arhetip: Archetype
  seed: string
  visinaSunca: number
  onGenerate(vrsta: VrstaTerena, arhetip: Archetype, seed: string): void
  onReset(): void
  onSunce(stepeni: number, konacno: boolean): void
}

export interface Hud {
  setReadout(html: string): void
  setSeed(seed: string): void
  setBusy(busy: boolean): void
}

const OPIS_EVROPE = 'Prava geografija, blaže planine, mreža puteva i mostova.'

export function buildHud(opts: HudOpts): Hud {
  const root = document.getElementById('ui')!
  let vrsta = opts.vrsta
  let arhetip = opts.arhetip

  root.innerHTML = `
    <div class="panel" id="title">
      <h1>TELEGRAF</h1>
      <p id="podnaslov"></p>
    </div>

    <div class="panel" id="mapctl">
      <h2>Mapa</h2>
      <div class="vrsta-grid">
        <button class="arch" data-vrsta="proceduralna">proceduralna</button>
        <button class="arch" data-vrsta="evropa">Evropa</button>
      </div>

      <div id="proc-opcije">
        <h2 class="razmak">Arhetip</h2>
        <div class="arch-grid">
          ${ARCHETYPES.map(
            (a) => `<button class="arch" data-arch="${a}" title="${ARCHETYPE_OPIS[a]}">${a}</button>`,
          ).join('')}
        </div>
      </div>

      <div class="row">
        <label for="seed">Seed</label>
        <input id="seed" spellcheck="false" autocomplete="off" />
      </div>
      <div class="row">
        <button class="act" id="gen">Generiši</button>
        <button class="act" id="novi">Nasumično</button>
      </div>
      <div class="row">
        <label for="sunce">Sunce</label>
        <input type="range" id="sunce" min="3" max="72" step="1" />
      </div>
      <p class="hint" id="opis"></p>
    </div>

    <div class="panel" id="help">
      <table>
        <tr><td>levi taster</td><td>pomeranje mape</td></tr>
        <tr><td>desni / shift</td><td>rotacija i nagib</td></tr>
        <tr><td>točkić</td><td>zum ka kursoru</td></tr>
        <tr><td>W A S D</td><td>pomeranje</td></tr>
        <tr><td>Q E / R F</td><td>rotacija / nagib</td></tr>
        <tr><td>Space</td><td>početni pogled</td></tr>
        <tr><td>G</td><td>nova mapa</td></tr>
        <tr><td>M</td><td>proceduralna / Evropa</td></tr>
        <tr><td>klik na teren</td><td>postavi kulu</td></tr>
        <tr><td>klik na kulu</td><td>izaberi je</td></tr>
        <tr><td>1 – 4</td><td>igrač</td></tr>
        <tr><td>Z X C</td><td>visina kule</td></tr>
        <tr><td>Delete</td><td>ukloni izabranu</td></tr>
      </table>
    </div>

    <div class="panel" id="readout"></div>
  `

  const seedInput = root.querySelector<HTMLInputElement>('#seed')!
  const opis = root.querySelector<HTMLParagraphElement>('#opis')!
  const podnaslov = root.querySelector<HTMLParagraphElement>('#podnaslov')!
  const readout = root.querySelector<HTMLDivElement>('#readout')!
  const sunce = root.querySelector<HTMLInputElement>('#sunce')!
  const procOpcije = root.querySelector<HTMLDivElement>('#proc-opcije')!
  const panel = root.querySelector<HTMLDivElement>('#mapctl')!

  seedInput.value = opts.seed
  sunce.value = String(opts.visinaSunca)

  function osveziIzbor(): void {
    for (const b of root.querySelectorAll<HTMLButtonElement>('button[data-vrsta]')) {
      b.dataset.on = b.dataset.vrsta === vrsta ? '1' : '0'
    }
    for (const b of root.querySelectorAll<HTMLButtonElement>('button[data-arch]')) {
      b.dataset.on = b.dataset.arch === arhetip ? '1' : '0'
    }
    const evropa = vrsta === 'evropa'
    procOpcije.hidden = evropa
    opis.textContent = evropa ? OPIS_EVROPE : ARCHETYPE_OPIS[arhetip]
    podnaslov.textContent = evropa
      ? 'Evropa · prototip terena'
      : `${arhetip} mapa · prototip terena`
  }

  function generisi(seed: string): void {
    opts.onGenerate(vrsta, arhetip, seed)
  }

  for (const b of root.querySelectorAll<HTMLButtonElement>('button[data-vrsta]')) {
    b.addEventListener('click', () => {
      if (vrsta === b.dataset.vrsta) return
      vrsta = b.dataset.vrsta as VrstaTerena
      osveziIzbor()
      generisi(seedInput.value.trim())
    })
  }

  for (const b of root.querySelectorAll<HTMLButtonElement>('button[data-arch]')) {
    b.addEventListener('click', () => {
      arhetip = b.dataset.arch as Archetype
      vrsta = 'proceduralna'
      osveziIzbor()
      generisi(seedInput.value.trim())
    })
  }

  root.querySelector('#gen')!.addEventListener('click', () => generisi(seedInput.value.trim()))
  root.querySelector('#novi')!.addEventListener('click', () => generisi(''))

  seedInput.addEventListener('keydown', (e) => {
    if ((e as KeyboardEvent).key === 'Enter') generisi(seedInput.value.trim())
  })

  sunce.addEventListener('input', () => opts.onSunce(Number(sunce.value), false))
  sunce.addEventListener('change', () => opts.onSunce(Number(sunce.value), true))

  window.addEventListener('keydown', (e) => {
    if (e.target instanceof HTMLInputElement) return
    if (e.code === 'Space') {
      e.preventDefault()
      opts.onReset()
    }
    if (e.code === 'KeyG') generisi('')
    if (e.code === 'KeyM') {
      vrsta = vrsta === 'evropa' ? 'proceduralna' : 'evropa'
      osveziIzbor()
      generisi(seedInput.value.trim())
    }
  })

  osveziIzbor()

  return {
    setReadout(html) {
      readout.innerHTML = html
    },
    setSeed(seed) {
      seedInput.value = seed
    },
    setBusy(busy) {
      panel.dataset.busy = busy ? '1' : '0'
    },
  }
}
